import Link from 'next/link';
import * as Typography from '@/components/shadcn/typography';
import CopyToClipboard from '@/components/ui/shared/CopyToClipboard';

interface Props {
  lat: number;
  lon: number;
}

export default function LatLng({ lat, lon }: Props) {
  return (
    <div className="flex">
      <Link
        href={`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${lat}%2C${lon}`}
        target="_blank">
        <Typography.H6>Lat:</Typography.H6>
        <Typography.H6>{lat}</Typography.H6>
        <br />
        <Typography.H6>Lon:</Typography.H6>
        <Typography.H6>{lon}</Typography.H6>
      </Link>
      <CopyToClipboard content={`${lat},${lon}`} />
    </div>
  );
}
